import api from "./api";

const uploadService = {
  generateToken: (payload) => {
    return api.post("/video-processing/upload-video", payload);
  },
};

export default uploadService;
